<template>
  <span class="apphome" style="display: block;padding: 20px;">
    <div class="apphome_box"
      style="display: block;padding: 20px;background: #fff;min-height: calc(100vh - 130px);position: relative;">

      <span style="margin-bottom:12px;display:block;">
        <el-button type="primary" @click="add_ed(0,listLength)">新增模块<i class="el-icon-document-add"></i>
        </el-button>
        <el-button icon="el-icon-upload " @click="exportList">导出excel</el-button>
      </span>
      <el-table id="demo"
        :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa'}"
        stripe :data="tableData" border style="width: 100%" row-key="Id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column type="index" label="#" width="80" align="center">
        </el-table-column>

        <el-table-column v-for="(item,index) in columns" :key='index' :label="item.name" :align="item.al"
          :width="item.width">
          <template slot-scope="{row}">
            <span v-if="item.key=='Type'">{{d[row[item.key]] || '-' }}</span>
            <span v-else-if="item.key=='State'">
              <el-tag v-if="row.State !=0">显示</el-tag>
              <el-tag v-else type="danger">隐藏</el-tag>
            </span>
            <span v-else>{{ row[item.key] || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图标" align="center" width="70">
          <template #default="{row}">
            <i v-if="row.IconCss" :style="'font-size:20px;color:'+ row.IconCss.split('/')[1]"
              :class="row.IconCss.split('/')[0]" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="400">
          <template #default="{row}">
            <!-- <el-button type="primary"  v-if="row.Name" @click="detail(row)">详情</el-button> -->
            <el-button type="primary" v-if="row.Name && !row.UpId" @click="add_ed(row.Id,row.children.length)">添加子模块
            </el-button>
            <el-button type="success" v-if="row.Name" @click="edit_ed(row)">编辑</el-button>
            <el-popconfirm v-if="row.Name" title="这是一段内容确定删除吗？" @onConfirm="delete_fn(row.Id)">
              <template #reference>
                <el-button type="danger">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination :page-sizes="[15, 20, 30, 40]" :page-size="listData.Rows" v-if="total>listData.Rows"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

      <!-- 选择图标 -->
      <el-dialog title="选择图标" v-dialogDrag :close-on-click-modal='false' :visible.sync="icon_status" width="82%" center>
        <icon v-if="icon_status" v-on:func="func"></icon>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="icon_status = false">取 消</el-button>
          </span>
        </template>
      </el-dialog>



      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        width="400" center>
        <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
          <el-form-item label="模块名:" prop="Name">
            <el-input v-model="temp.Name"></el-input>
          </el-form-item>
          <el-form-item label="字体图标" prop="IconCss">
            <i :style="'font-size:20px;color:'+ temp.IconCss.split('/')[1]" v-if="temp.IconCss"
              :class="temp.IconCss.split('/')[0]" />
            <el-button type="primary" @click="icon_status = true">选择图标</el-button>
          </el-form-item>
          <el-form-item label="路由:" prop="RouteUrl">
            <el-select v-model="temp.RouteUrl" placeholder="请选择路由" filterable clearable>
              <el-option v-for="(item,i) in routerUrl" :key="i" :label="item.name" :value="item.RouteUrl">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="编码:" prop="Code">
            <el-input v-model="temp.Code" placeholder="请输入编码"></el-input>
          </el-form-item>
          <el-form-item label="等级:">
            <el-input v-model="temp.TreeLevel" type="number"></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-radio v-model="temp.State" label="1">显示</el-radio>
            <el-radio v-model="temp.State" label="0">隐藏</el-radio>
          </el-form-item>
          <el-form-item v-if="temp.RouteUrl == 'newUrl' || temp.RouteUrl == 'administrator'" label="跳转路径:"
            prop="NewTabUrl">
            <el-input v-model="temp.NewTabUrl"></el-input>
          </el-form-item>
          <el-form-item v-if="temp.RouteUrl == 'svged'" label="svg图:" prop="PageId">
            <el-select v-model="temp.PageId" filterable placeholder="请选择svg图">
              <el-option v-for="item in treeList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input v-model="temp.SerialNo" type="number"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

    </div>
  </span>
</template>
<script>
  //   import { AppModuleRightAdd, AppModuleRightDelete, AppModuleRightEdit } from "@/utils/request";


  // import icon from '@/components/icon';
  import icon from "@/page/icons"; // secondary
  import resourcesStore from '@/cache/resourcesStore.js'
  export default {
    components: {
      icon
    },
    data () {
      var validatePass=(rule,value,callback) => {
        if(!this.temp.IconCss) {
          callback(new Error('请选择图标'));
        } else {
          callback();
        }
      };
      return {
        d: {
          Module: '模块',
          Right: '权限'
        },
        total: 0,
        list: '',
        imageUrl: '',
        routerUrl: [],
        icon_status: false,
        detail_status: false,
        Password: '',
        passwordType: true,//切换密码展示
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        tableData: [],

        heights: document.body.clientHeight-18,
        defaultProps: {
          children: "next",
          label: "name"
        },
        dialogVisible: false,
        rules: {
          PageId: [
            {required: true,message: '请选择svg图',trigger: 'change'}
          ],
          NewTabUrl: [
            {required: true,message: '请输入路径',trigger: 'blur'}
          ],
          Name: [
            {required: true,message: '请输入模块名',trigger: 'blur'}
          ],
          Code: [
            {required: true,message: '请输入编码',trigger: 'blur'}
          ],
          Type: [
            {required: true,message: '请选择类型',trigger: 'change'}
          ],
          IconCss: [
            {validator: validatePass,trigger: "change"},
          ],
          RouteUrl: [
            {required: true,message: '请选择路由',trigger: 'change'}
          ],

        },
        treeList: [],
        listData: {
          "Page": 1,
          "Rows": 999,
          "Sorts": [
            {
              "Field": "SerialNo",
              "OrderByType": 0
            }
          ],
        },
        columns: [{
          name: "模块名",
          key: "Name",
          width: 220,
          al: 'left'
        },{
          name: "路由",
          key: "RouteUrl",
          width: 220,
          al: 'center'
        },{
          name: "等级",
          key: "TreeLevel",
          width: 90,
          al: 'center'
        },{
          name: "排序",
          key: "SerialNo",
          width: 90,
          al: 'center'
        },{
          name: "编码",
          key: "Code",
          width: 120,
          al: 'center'
        },{
          name: "类型",
          key: "Type",
          width: 120,
          al: 'center'
        },{
          name: "状态",
          key: "State",
          width: 90,
          al: 'center'
        }],
        abc: [],
      };
    },
    computed: {
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
    },
    mounted () {


      this.abc=[]
      //   this.routerUrl = Object.assign([], this.$store.state.settings.routerUrl);
      this.routerUrl=Object.assign([],this.abc);
      this.getList();//获取列表数据 
      // 获取树形
      var res={
        "Status": 200,
        "Success": true,
        "Msg": "获取成功",
        "Response": []
      }
      //   GetConfigurationPageOrganizationAsync().then(res => {
      if(res&&res.Success&&res.Response.length) {

        this.treeList=[];
        res.Response.map(v => {
          if(v.Category=='Page') {
            this.treeList.push(v);
          }
        });
        console.log(this.treeList);
      }
      //   })
    },
    methods: {

      //下载excel表格
      exportList () {
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader=[];
          var filterVal=[];
          for(const key in this.columns) {
            if(Object.hasOwnProperty.call(this.columns,key)) {
              tHeader.push(this.columns[key].key);
              filterVal.push(this.columns[key].key);
            }
          }
          tHeader.unshift('Id');
          filterVal.unshift('Id');
          const list=this.tableData;
          const data=this.formatJson(filterVal,list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: '路由数据',
            autoWidth: true,
            bookType: 'xlsx'
          });
        });
      },
      formatJson (filterVal,jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          return v[j];
        }));
      },
      // 排除路由
      delete_router () {
        // this.routerUrl = Object.assign([], this.$store.state.settings.routerUrl);
        this.routerUrl=Object.assign([],this.abc);
        this.list.map(v => {
          for(let i=0;i<this.routerUrl.length;i++) {
            if(this.routerUrl[i].RouteUrl==v.RouteUrl&&this.routerUrl[i].RouteUrl!='Wrapper'&&this.routerUrl[i].RouteUrl!='newUrl'&&this.routerUrl[i].RouteUrl!='svged'&&this.routerUrl[i].RouteUrl!='administrator') {
              this.routerUrl.splice(i,1);
            }
          }
        })
      },


      //先根据id和parentId的关系生成关系树
      makeTree (arr,Id) {
        var temp=[];
        for(var i=0;i<arr.length;i++) {
          //如果某个元素的parentId和传入的pid相等，作为pid对应id对象的children集合中的数据
          if(arr[i].UpId==Id) {
            temp.push(arr[i]);
            //再递归的生成关系树
            arr[i].children=this.makeTree(arr,arr[i].Id);
          }
        }
        return temp;
      },
      //详情
      detail (v) {
        this.temp=v;
        this.detail_status=true;
      },
      // 删除管理员
      delete_fn (v) {
        // AppModuleRightDelete(v).then(data => {
        //   if (data.Success) {
        //     this.$message({ showClose: true, message: '删除成功', type: 'success' });
        //     this.getList();
        //   } else {
        //     data.Msg ? this.$message.error(data.Msg) : this.$message.error('删除失败');
        //   }
        // })
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            AppModuleRightAdd(this.temp).then(data => {
              if(data.Success) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(data.Msg) {
                  this.$message.error(data.Msg);
                } else {
                  this.$message.success('添加失败');
                }
              }

            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v,l) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.Password='';
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={
          UpId: v||null,
          SerialNo: l+1,
          FromClass: '1',
          State: '1',
          Type: 'Module',
        };
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            delete this.temp.children;
            AppModuleRightEdit(this.temp).then(data => {
              if(data.Success) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                data.Msg? this.$message.error(data.Msg):this.$message.error('修改失败');
              }

            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {

        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.$set(this.temp,'State',this.temp.State!=0? '1':'0')
        this.Password='';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },

      //接受图标
      func (e) {
        this.$set(this.temp,'IconCss',e);
        this.icon_status=false;
      },

      //获取列表数据
      getList () {
        var res={}
        // AppModuleRight(this.listData).then(res => {
        if(res.Success) {
          this.list=JSON.parse(JSON.stringify(res.Response.data));
          this.tableData=this.makeTree(res.Response.data,null);
          this.listLength=this.tableData.length;
          setTimeout(() => {
            this.delete_router();
          },300);
          localStorage.setItem('layoutData',JSON.stringify(this.tableData));
        }
        // });

      },


    }
  };
</script>

<style lang="scss" scoped>
  .select_tree {
    .el-tree-node {
      .is-leaf+.el-checkbox .el-checkbox__inner {
        display: inline-block;
      }

      .el-checkbox__input>.el-checkbox__inner {
        display: none;
      }
    }

  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  /deep/.el-table__body-wrapper {
    width: 95% !important;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>